import { atom } from "recoil";

import { NotDraggingDataConst } from "../../constants";
import { TDragStationRouteData } from "../../models";

export const stationRouteHasUnsavedStationsChangeAtom = atom<boolean>({
  key: "stationRouteHasUnsavedStationsChangeAtom",
  default: false,
});

export const stationRouteEditHasMetadataChangedAtom = atom<boolean>({
  key: "stationRouteEditHasMetadataChangedAtom",
  default: false,
});

export const stationRouteDraggingStationsTempIdsAtom = atom<
  number[] | undefined
>({
  key: "stationRouteDraggingStationsTempIdsAtom",
  default: undefined,
});

export const stationRouteDraggingDataAtom = atom<TDragStationRouteData>({
  key: "stationRouteDraggingDataAtom",
  default: NotDraggingDataConst,
});

export const stationRouteMatchingMlPathsExpandedAtom = atom<boolean>({
  key: "stationRouteMatchingMlPathsExpandedAtom",
  default: false,
});

export const stationRouteMatchingMlPathIdsAtom = atom<number[]>({
  key: "stationRouteMatchingMlPathIdsAtom",
  default: [],
});

export const stationRouteMatchingMlPathUpdateIdAtom = atom<number | null>({
  key: "stationRouteMatchingMlPathUpdateIdAtom",
  default: null,
});
